import { useAuth } from '@kitopi-com/auth';
import { ThemeProvider as KitopiUiThemeProvider } from '@kitopi-com/ui';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { authConfig } from 'auth.config';
import { AppVersionNotification } from 'components/AppVersionNotification/AppVersionNotification';
import { AppWrapper } from 'components/AppWrapper/AppWrapper';
import { ConfirmationDialogProvider } from 'components/common/ConfirmationDialog/ConfirmationDialogProvider';
import { SuspenseRoute } from 'components/common/SuspenseRoute/SuspenseRoute';
import ErrorBoundary from 'components/ErrorBoundary';
import { FeatureToggles } from 'components/FeatureToggles/FeatureToggles';
import { useAppTheme } from 'hooks/useAppTheme';
import ModalProvider from 'mui-modal-provider';
import { SnackbarProvider } from 'notistack';
import { type FunctionComponent, lazy } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { DialogUtilsConfigurator } from 'utils/dialog';
import { SnackbarUtilsConfigurator } from 'utils/notifications';
import { oldTheme } from 'utils/theme/oldTheme';
import { GlobalCCPStyles, GlobalStyles } from './styles';

const AppRoutes = lazy(() => import('./AppRoutes'));

export const Routes: FunctionComponent = () => {
  const { isInitialized: isAuthInitialized } = useAuth(authConfig);
  const { theme } = useAppTheme();
  return (
    <>
      <GlobalStyles />

      <Switch>
        <Redirect exact from="/" to="/app" />
        <SuspenseRoute path="/app/">
          <KitopiUiThemeProvider theme={theme}>
            <MuiThemeProvider theme={oldTheme}>
              <SnackbarProvider
                preventDuplicate
                style={{ pointerEvents: 'all', marginBottom: '6px', marginTop: '6px' }}
              >
                <ConfirmationDialogProvider>
                  <ModalProvider>
                    <SnackbarUtilsConfigurator />
                    <DialogUtilsConfigurator />
                    <FeatureToggles />
                    <GlobalCCPStyles />
                    <ErrorBoundary>
                      <AppWrapper isAuthInitialized={isAuthInitialized}>
                        <AppRoutes />
                      </AppWrapper>
                    </ErrorBoundary>
                    {!process.env.DEV_MODE && <AppVersionNotification />}
                  </ModalProvider>
                </ConfirmationDialogProvider>
              </SnackbarProvider>
            </MuiThemeProvider>
          </KitopiUiThemeProvider>
        </SuspenseRoute>
      </Switch>
    </>
  );
};
